(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emdu-size-guide-near-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emdu-size-guide')) {
    customElements.define('emdu-size-guide', class extends HTMLElement {
      static nextInstance = 0;

      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-guide-open]');
        if (!this.dialog || !this.trigger) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const suffix = `-${++this.constructor.nextInstance}`;
        const ids = new Map();
        this.querySelectorAll('[id]').forEach((node) => {
          const oldId = node.id;
          node.id = oldId + suffix;
          ids.set(oldId, node.id);
        });
        this.querySelectorAll('[aria-controls], [aria-labelledby], [aria-describedby]').forEach((node) => {
          ['aria-controls', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
            if (!node.hasAttribute(attribute)) return;
            node.setAttribute(attribute, node.getAttribute(attribute).split(' ').map((id) => ids.get(id) || id).join(' '));
          });
        });
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-fit-panel]'));
        this.trigger.addEventListener('click', () => this.openGuide(), options);
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectFit(tab.dataset.fit), options);
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.selectFit(this.tabs[next].dataset.fit);
            this.tabs[next].focus();
          }, options);
        });
      }

      selectedFit() {
        const scope = this.closest('.product-single__primary-blocks') || this.closest('[data-product-id]') || this.parentElement;
        const picker = scope.querySelector('variant-radios, variant-selects') || scope;
        let fit = '';
        let colour = '';
        picker.querySelectorAll('input:checked, select').forEach((input) => {
          const name = (input.name || '').replace(/^options\[|\]$/g, '').toLowerCase();
          if (name === 'fit') fit = input.value;
          if (name === 'colour' || name === 'color') colour = input.value;
        });
        if (/oversiz/i.test(fit)) return /faded/i.test(colour) ? 'faded' : 'oversize';
        return 'regular';
      }

      selectFit(fit) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.fit === fit;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.fitPanel !== fit; });
      }

      openGuide() {
        if (this.dialog.open) return;
        if (this.tabs.length) this.selectFit(this.selectedFit());
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.querySelector('.emdu-sizing__body').scrollTop = 0;
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
